import { Link } from 'react-router-dom';
import { FolderOpenOutlined } from '@ant-design/icons';
import { Highlight } from '@/shared/ui/Highlight';
import { useStudyPrefetch } from '@/state/hooks/useStudyPrefetch';
import { formatName, formatDate } from '@/utils/search';
import type { SearchStudy } from '@/models/search';
import styles from '../styles/ResultRow.module.css';

export const StudyRow = ({
  study,
  query,
}: {
  study: SearchStudy;
  query: string;
}) => {
  const prefetchStudy = useStudyPrefetch();
  const studyDate = formatDate(study.studyDate);
  return (
    <Link
      to={`/studies/${study.uuid}`}
      className={styles.resultRow}
      onMouseEnter={() => prefetchStudy(study.uuid)}
    >
      <div className={`${styles.resultIcon} ${styles.study}`}>
        <FolderOpenOutlined />
      </div>
      <div className={styles.resultContent}>
        <span className={styles.resultPrimary}>
          <Highlight
            text={formatName(study.patientFirstName, study.patientLastName)}
            query={query}
          />
          {study.modality && (
            <span className={`${styles.tag} ${styles.tagStudy}`}>
              {study.modality}
            </span>
          )}
          {studyDate && (
            <span className={styles.resultMeta}> · {studyDate}</span>
          )}
        </span>
        {study.accessionNumber && (
          <span className={styles.resultSecondary}>
            ACC: <Highlight text={study.accessionNumber} query={query} />
          </span>
        )}
      </div>
      <span className={`${styles.typeBadge} ${styles.study}`}>Study</span>
    </Link>
  );
};
